import { Box, Flex, Text, Spinner, Center} from "@chakra-ui/react";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import MyDiv from "./candidateStatusCard.style";

ChartJS.register(ArcElement, Tooltip, Legend);

const chartColors = ["#F4A79D", "#F68D2B", "#344BFD", "#49A677", "#FA898B"];

interface CandidateStausProps {
  candidateStatusCount: any,
  loading: boolean;
}

const CandidateStatusCard = ({ candidateStatusCount, loading }: CandidateStausProps) => {

  const labels = candidateStatusCount?.map((item: { label: any; }) => item.label) || [];
  const counts = candidateStatusCount?.map((item: { value: any; }) => item.value) || [] ;

  const hasData = counts.some((val:any) => val > 0);

  const chartData = hasData
    ? {
        labels,
        datasets: [
          {
            data: counts,
            backgroundColor: chartColors,
            borderWidth: 0,
            cutout: "60%",
          },
        ],
      }
    : {
        labels: ["No Data"],
        datasets: [
          {
            data: [1], 
            backgroundColor: ["#778899"], 
            borderWidth: 0,
            cutout: "60%",
          },
        ],
      };

  const options = {
    responsive: true,
    plugins: {
      legend: { display: false },
      tooltip: { enabled: hasData },
    },
  };

  const noDataPlugin = {
    id: "noDataPlugin",
    beforeDraw: (chart: any) => {
      if (hasData) return;
      const { width, height, ctx } = chart;
      ctx.save();
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      ctx.font = "16px Poppins";
      ctx.fillStyle = "black";
      ctx.fillText("No Data Available", width / 2, height / 2);
      ctx.restore();
    },
  };


return (
    <MyDiv>
      <Box className="card_box" minH="350px">
        <Text className="font-poppins text_xl text_medium">Candidate Status Distribution</Text>

        {loading ? (
          <Center h="280px">
            <Spinner size="lg" color="blue.500" />
          </Center>
        ) : (
          <Flex align="center" justify="space-between" mb={6}>
            <Box className="donut-chart">
             <Doughnut data={chartData} options={options} plugins={[noDataPlugin]} />
            </Box>

            {hasData && (
              <Box position="relative" flex={1} pl={20}>
                {labels.map((label: string, i: number) => (
                  <Flex key={i} align="center" justify="space-between" mb={3} className="legend-row">
                    <Flex align="center">
                      <Box w="14px" h="14px" borderRadius="sm" bg={chartColors[i % chartColors.length]} />
                      <Text ml={2} className="font-poppins text_lg text_medium">{label}</Text>
                      <Text className="font-poppins text_lg text_medium">({counts[i]})</Text>
                    </Flex>
                  </Flex>
                ))}
              </Box>
            )}
          </Flex>
        )}
      </Box>
    </MyDiv>
  );
};

export default CandidateStatusCard;
